import { useI18n } from "i18n";
import { Container } from "@remo-co/ui-core/src/components/Container";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { RemoLogo } from "@remo-co/ui-core/src/components/RemoLogo";
import { useStyles } from "./styles";
import {
  certificateLogos,
  footerData,
  ratings,
  socialMediaPlatforms,
} from "./constants";
import virtualEvent from "./assets/virtual-event-platforms-leader.png";
import capterraBadge from "./assets/cap-dark-shortlist-badge.webp";

export const Footer = (): JSX.Element | null => {
  const styles = useStyles();
  const { t } = useI18n(["footer", "url"]);

  return (
    <Container className={styles.container} data-testid="footer-container">
      <div className={styles.innerContainer}>
        <div className={styles.wrapper}>
          <RemoLogo
            variant="large-logo-white"
            size="lg"
            width={200}
            className={styles.remoLogo}
          />
          <div className={styles.footerGrid}>
            <div className={styles.columnsContainer}>
              {footerData.map((footer) => (
                <div className={styles.columnDiv} key={footer.heading}>
                  <Typography variant="h4" className={styles.columnHeading}>
                    {t(footer.heading)}
                  </Typography>
                  {Object.entries(footer.subLinks).map(([name, link]) => (
                    <a href={t(link)} className={styles.columnLinks} key={name}>
                      {t(name)}
                    </a>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className={`${styles.wrapper} ${styles.bottomWrapper}`}>
        <div className={styles.footerMain}>
          <div className={styles.bottomContainer}>
            <div className={styles.certificateContainer}>
              {certificateLogos.map(({ src, alt }) => (
                <div className={styles.certificateImage} key={alt}>
                  <img src={src} alt={alt} className={styles.image} />
                </div>
              ))}
            </div>
            <div className={styles.ratingMainDiv}>
              {ratings.map(({ src, alt, text, link }) => (
                <div className={styles.ratingDiv} key={alt}>
                  <a href={t(link)} className={styles.ratingBox}>
                    <img
                      src={src}
                      alt={alt}
                      className={`${styles.ratingImage} ${styles.image}`}
                      width={162}
                    />
                    <Typography>{t(text)}</Typography>
                  </a>
                </div>
              ))}
              <Typography className={styles.compliant}>
                {t("remo.compliant")}
              </Typography>
              <div className={`${styles.ratingDiv} ${styles.paddingTop0}`}>
                <div>
                  <img
                    src={virtualEvent}
                    alt="virtual-event"
                    className={`${styles.ratingImage} ${styles.image}`}
                    width={122}
                  />
                </div>
              </div>
              <div className={`${styles.ratingDiv} ${styles.paddingTop0}`}>
                <div>
                  <img
                    src={capterraBadge}
                    alt="capterra-badge"
                    className={`${styles.ratingImage} ${styles.image}`}
                    width={162}
                  />
                </div>
              </div>
            </div>
            <div className={styles.followUs}>
              <Typography variant="h4" className={styles.followUsText}>
                {t("follow.us")}
              </Typography>
              <div className={styles.platforms}>
                {socialMediaPlatforms.map(({ href, src, alt }) => (
                  <a href={t(href)} target="_blank" rel="noreferrer" key={alt}>
                    <img
                      src={src}
                      alt={alt}
                      className={styles.image}
                      width={20}
                      height={20}
                    />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};
